import { useRouter } from "next/router";
import { useState } from "react";
import { client } from "../graphql/client";
import { queryMap } from "../utils/query/publication";

const sorted = (order, category) => {
  if (order === "asc") {
    return category + " Terdahulu";
  }

  return category + " Terbaru";
};

export const getEventsPublications = async ({
  category,
  title,
  limit = 10,
  page = 1,
  order = "desc",
}) => {
  let newTitle = title?.length > 0 ? "%" + title + "%" : "%%";

  let variables = {
    limit: limit,
    offset: limit * (page - 1),
    order: { created_at: order },
  };

  if (category !== "e-brocure") {
    variables["title"] = newTitle;
  }

  const { data, fetching, error } = await client
    .query(queryMap[category], {
      ...variables,
    })
    .toPromise();
  return { data, fetching, error };
};

export function useEventsPublications({ cat }) {
  const { push, query } = useRouter();

  const {
    query: { order, page = 1, title = "" },
  } = useRouter();
  const [search, setSearch] = useState(title || "");
  const [open, setOpen] = useState(true);
  const [pages, setPages] = useState(parseInt(page) || 1);
  const [selected, setSelected] = useState(
    sorted(order, cat) || cat + " Terbaru"
  );

  const handleChange = (url, type, value) => {
    push({
      pathname: url,
      query: {
        ...query,
        [type]: value,
      },
    });
  };

  const handleOrder = (e, url) => {
    setSelected(e.text);
    let newValue = e.value === 0 ? "desc" : "asc";
    handleChange(url, "order", newValue);
  };

  const handlePage = (number, url) => {
    setPages(number);
    handleChange(url, "page", number);
  };
  return {
    search,
    setSearch,
    handleChange,
    handleOrder,
    handlePage,
    open,
    setOpen,
    pages,
    selected,
  };
}
